export default __webpack_public_path__ + "static/media/Tools-P15-CIFOR.39d33675.jpg";